import { render, staticRenderFns } from "./FloatBall.vue?vue&type=template&id=22cf8b92&scoped=true"
import script from "./FloatBall.vue?vue&type=script&lang=js"
export * from "./FloatBall.vue?vue&type=script&lang=js"
import style0 from "./FloatBall.vue?vue&type=style&index=0&id=22cf8b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf8b92",
  null
  
)

export default component.exports